import { render, staticRenderFns } from "./DoctorReport.vue?vue&type=template&id=6bda138e&scoped=true"
import script from "./DoctorReport.vue?vue&type=script&lang=ts"
export * from "./DoctorReport.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReport.vue?vue&type=style&index=0&id=6bda138e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda138e",
  null
  
)

export default component.exports